module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/store_images/3_ce704d9d17ca8cb616c7a5989e90b306.png";